import clsx from 'clsx';
import React from 'react';
import { textColorStyles, type TextColor } from '../styles/colors';

export interface LabelProps {
  children: React.ReactNode;
  className?: string;
  color?: TextColor;
  size?: 'tiny' | 'small' | 'base' | 'large';
}

const FONT_FAMILY = 'Inter, sans-serif';
const FONT_WEIGHT = 'var(--font-weight-medium)';

const sizeStyles = {
  tiny: { fontSize: '0.75rem', lineHeight: '1rem' },
  small: { fontSize: '0.875rem', lineHeight: '1.25rem' },
  base: { fontSize: '1rem', lineHeight: '1.5rem' },
  large: { fontSize: '1.125rem', lineHeight: '1.75rem' },
};

export const Label = ({ children, className, color = 'primary-black', size = 'base' }: LabelProps) => (
  <p
    className={clsx(textColorStyles[color], className)}
    style={{
      fontFamily: FONT_FAMILY,
      ...sizeStyles[size],
      fontWeight: FONT_WEIGHT,
    }}
  >
    {children}
  </p>
);
